import { resolveErrorMessage, resolveStructuredErrorMessage } from '../utils/errorMessage';

export const buildImmediatePublishParams = ({ currentPublishRecord, targetAccountIds }) => ({
  content_ids: [currentPublishRecord.content_id],
  target_account_ids: targetAccountIds,
  publisher_user_id: currentPublishRecord.creator_user_id || 'aispire',
  template_type: currentPublishRecord.content_type || '视频',
});

export const collectPublishExecutionIssues = (response) => {
  const created = Array.isArray(response?.created) ? response.created : [];
  const skipped = Array.isArray(response?.skipped) ? response.skipped : [];
  const issues = [];

  created.forEach((item) => {
    const structured = resolveStructuredErrorMessage(item?.error, '');
    const fallback = resolveErrorMessage(item?.error_message || item?.error_code, '');
    const messageText = structured || fallback;
    if (!messageText) return;
    issues.push({
      key: `created:${item?.publish_id || item?.content_id || item?.account_id || messageText}`,
      message: messageText,
      platform: item?.platform_display || item?.platform_code || '',
      accountName: item?.account_name || '',
    });
  });

  skipped.forEach((item) => {
    const structured = resolveStructuredErrorMessage(item?.error, '');
    const fallback = resolveErrorMessage(item?.reason || item?.error_message || item?.error_code, '');
    const messageText = structured || fallback;
    if (!messageText) return;
    issues.push({
      key: `skipped:${item?.content_id || item?.account_id || item?.existing_publish_id || messageText}`,
      message: messageText,
      platform: item?.platform_display || item?.platform_code || '',
      accountName: item?.account_name || '',
    });
  });

  return issues;
};

export const analyzeImmediatePublishResponse = (response) => {
  const createdItems = Array.isArray(response?.created) ? response.created : [];
  const skippedItems = Array.isArray(response?.skipped) ? response.skipped : [];
  const successLike = createdItems.filter((item) => ['success', 'publishing', 'pending'].includes(String(item?.status || '').toLowerCase()));
  const failedLike = createdItems.filter((item) => ['failed', 'conflict'].includes(String(item?.status || '').toLowerCase()));
  const issues = collectPublishExecutionIssues(response);
  const allFailed = successLike.length === 0 && (failedLike.length > 0 || skippedItems.length > 0);
  const partiallyFailed = successLike.length > 0 && issues.length > 0;
  return {
    createdItems,
    skippedItems,
    successLike,
    failedLike,
    issues,
    allFailed,
    partiallyFailed,
  };
};
